module.exports = __webpack_public_path__ + "plugins/web/img/cmdinfo-bg2.e9f78a9c.jpg";